/*
 * =============================================================================
 * Project: payments.telestrada-online.pl
 * Created Date: 2018-07-11, 17:05:04
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-07-18, 17:01:04
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import axios from 'axios';
import { errorHandlerInterceptor } from './interceptors';

const API_HEADERS = {};
const API_CONFIG = {};
const API_TOKEN_STORAGE = sessionStorage;

// SET CONFIGURATION
API_HEADERS['X-Requested-With'] = 'XMLHttpRequest';

API_CONFIG.baseURL = process.env.API_URL;
API_CONFIG.headers = API_HEADERS;
API_CONFIG.timeout = 10000;
API_CONFIG.withCredentials = !process.env.NODE_ENV === 'development';

const API = axios.create(API_CONFIG);

API.interceptors.request.use(config => config, errorHandlerInterceptor);
API.interceptors.response.use(config => config, errorHandlerInterceptor);

// EXPORT CONFIGURATION
export {
  API, API_TOKEN_STORAGE,
};



// WEBPACK FOOTER //
// ./src/config/index.js